/**
 * Generates a random string of specified length using Base58 character set
 * Base58 excludes characters that might be confused with each other:
 * 0 (zero), O (capital o), I (capital i), l (lowercase L)
 *
 * @param {number} length - The length of the random string to generate
 * @returns {string} A random Base58 string of the specified length
 */
export function randomBase58(length) {
  const chars = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}
